module.exports = __webpack_public_path__ + "img/person.e2db7078.svg";